export default __webpack_public_path__ + "static/media/Etape-4_VIEUX-FONDS_DEF.fa978956.mp3";